import { IApplicationState } from '../../types/redux';

export function selectCompareLink(state: IApplicationState): string {
  return state.servicesLinks.compare;
}
